__turbopack_context__.v({
  "className": "inter_4cd1db6c-module__ppHgsq__className",
});
